/*
 * Returns a number rounded to a specified number of decimals
 * @param value The number to round
 * @param decimals The number of decimals to round to
 */
export function round(value: number, decimals: number = 2): number {
	const factor = Math.pow(10, decimals)
	return Math.round(value * factor) / factor
}
